export const VISITOR_CONSTANT = {
  VISITOR_LIST: "/visitor/list",
  VISIT_DATA: "/visitor/visits/entry",
  UPDATE_VISIT_DATA: "/visitor/visits/entry/update",
  VISITOR_DATA: "/visitor",
  VISITOR_ENTRY: "/visitor/entry",
  VISITOR_VISITS_ENTRY: "/visitor/visits/entry",
  VISITOR_SEARCH: "/visitor/search",
  TOTAL_COUNT: "/visitor/visitors/unique/count",
  VISITS_COUNT: "/visits/total/count",
  // CAST: "/visitor/cast/subcast",
  TOKEN_GENERATE: "/visitor/token/generate",
  TOKEN_LIST: "/visitor/visits/list",
  VISITS_TOTAL_COUNT: "/visitor/visits/today/count",
  UPDATE_VISITS: "/visitor/visits/update",
  UPDATE_ACT_VISIT_DATE: "/visitor/visits/entry/update",
  GET_CSV: "/visitor/export/masterdata",
  GET_CSV_VISIT: "/visitor/export/visits",
};

export const EXCEL_FILE_DATA = {
  COLUMN_DEFINATION: [
    {
      isObj: false,
      displayName: "Id",
      valueKey: ["id"],
    },
    {
      isObj: true,
      displayName: "UId",
      obj: "visitor",
      valueKey: ["uniqueId"],
    },
    {
      isObj: true,
      displayName: "Name",
      obj: "visitor",
      valueKey: ["firstName", "middleName", "lastName"],
    },
    {
      isobj: true,
      displayName: "Mobile Number",
      obj: "visitor",
      valueKey: ["phone"],
    },
    {
      isobj: true,
      displayName: "E-mail",
      obj: "visitor",
      valueKey: ["email"],
    },
    {
      isObj: true,
      displayName: "Identity Card No",
      obj: "visitor",
      valueKey: ["aadhar", "pancard"],
    },
    {
      isObj: false,
      displayName: "Visit Purpose",
      valueKey: ["purposeCategory"],
    },
    {
      isObj: false,
      displayName: "Visited  Date",
      valueKey: ["createdDate"],
      type: "DATE",
    },
    // {
    //   isObj: false,
    //   displayName: "Address",
    //   obj: "visitor.addressFields",
    //   valueKey: ["addressLine1", "addressLine2", "city", "district", "flatNo", "pincode"],
    // },
  ],
};
